import { useState, useEffect } from 'react';

export default function Hero() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      image: "https://static.readdy.ai/image/31562a2a45c0a727692c38b1929c3137/95de3eee0dbac9474cbac1cd757ad66e.png",
      alt: "HIPERCLEAN - Toallas en rollo profesionales"
    },
    {
      image: "https://public.readdy.ai/ai/img_res/a9020ddafa2ad63112aeadae7a1de9ce.jpg",
      alt: "Almacén limpio y organizado"
    },
    {
      image: "https://readdy.ai/api/search-image?query=premium%20hygiene%20products%20paper%20towels%20toilet%20paper%20rolls%20displayed%20on%20white%20background%20professional%20product%20photography%20clean%20minimalist%20corporate%20aesthetic%20bright%20lighting%20high%20quality%20industrial%20supplies&width=1920&height=1080&seq=hero-hygiene-002&orientation=landscape",
      alt: "Productos higiénicos profesionales"
    },
    {
      image: "https://readdy.ai/api/search-image?query=industrial%20chemical%20warehouse%20with%20organized%20shelves%20professional%20cleaning%20chemicals%20bottles%20containers%20white%20and%20blue%20corporate%20aesthetic%20bright%20lighting%20safety%20equipment%20modern%20facility%20pristine%20environment&width=1920&height=1080&seq=hero-chemicals-003&orientation=landscape",
      alt: "Almacén de químicos industriales"
    },
    {
      image: "https://public.readdy.ai/ai/img_res/f16f1034-5c73-4443-9df2-e503615ed65b.png",
      alt: "Soluciones corporativas"
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <section id="inicio" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-white">
      {/* Carousel Images */}
      <div className="absolute inset-0">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === currentSlide ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img 
              src={slide.image}
              alt={slide.alt}
              className="w-full h-full object-cover object-center"
            />
          </div>
        ))}
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      {/* Navigation Arrows */}
      <button 
        onClick={prevSlide}
        className="absolute left-6 top-1/2 -translate-y-1/2 z-20 w-12 h-12 flex items-center justify-center bg-white/10 backdrop-blur-sm rounded-full border border-white/20 cursor-pointer hover:bg-white/20 transition-all"
      >
        <i className="ri-arrow-left-s-line text-white text-2xl"></i>
      </button>
      <button 
        onClick={nextSlide}
        className="absolute right-6 top-1/2 -translate-y-1/2 z-20 w-12 h-12 flex items-center justify-center bg-white/10 backdrop-blur-sm rounded-full border border-white/20 cursor-pointer hover:bg-white/20 transition-all"
      >
        <i className="ri-arrow-right-s-line text-white text-2xl"></i>
      </button>

      {/* Content */}
      <div className="relative z-10 w-full max-w-6xl mx-auto px-6 lg:px-8 text-center py-32">
        {/* Rating Badge */}
        <div className="flex items-center justify-center gap-3 mb-8">
          <div className="flex items-center gap-1">
            <i className="ri-star-fill text-yellow-400 text-lg"></i>
            <i className="ri-star-fill text-yellow-400 text-lg"></i>
            <i className="ri-star-fill text-yellow-400 text-lg"></i>
            <i className="ri-star-fill text-yellow-400 text-lg"></i>
            <i className="ri-star-half-fill text-yellow-400 text-lg"></i>
          </div>
          <span className="text-white font-medium text-base">4.8/5</span>
          <span className="text-white/80 text-sm">en Google (6 opiniones)</span>
        </div>

        {/* Main Heading */}
        <h1 className="text-5xl sm:text-6xl lg:text-7xl font-light text-white mb-6 leading-tight tracking-tight">
          Solucion profesional en<br />higiene y suministro industrial
        </h1>
        
        {/* Subtitle */}
        <p className="text-xl sm:text-2xl text-white/90 mb-12 max-w-3xl mx-auto font-light">
          Abastecimiento confiable para empresas en la región centro de México
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-20">
          <a 
            href="mailto:hiperclean@hotmail.com" 
            className="w-full sm:w-auto px-8 py-3.5 bg-blue-600 text-white text-base font-medium rounded-lg hover:bg-blue-700 transition-all whitespace-nowrap cursor-pointer"
          >
            Solicitar cotización
          </a>
          <a 
            href="https://wa.me/524492037021" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="w-full sm:w-auto px-8 py-3.5 bg-green-600 text-white text-base font-medium rounded-lg hover:bg-green-700 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line mr-2"></i>Contactar por WhatsApp
          </a>
        </div>

        {/* Feature Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-5xl mx-auto">
          <div className="bg-white/5 backdrop-blur-md rounded-2xl p-8 border border-white/10">
            <div className="w-14 h-14 bg-blue-600/90 rounded-xl flex items-center justify-center mx-auto mb-5">
              <i className="ri-shield-check-line text-white text-2xl"></i>
            </div>
            <h3 className="text-white font-medium text-lg mb-3">Calidad certificada</h3>
            <p className="text-white/70 text-sm font-light leading-relaxed">Productos de las mejores marcas con garantía empresarial</p>
          </div>

          <div className="bg-white/5 backdrop-blur-md rounded-2xl p-8 border border-white/10">
            <div className="w-14 h-14 bg-blue-600/90 rounded-xl flex items-center justify-center mx-auto mb-5">
              <i className="ri-truck-line text-white text-2xl"></i>
            </div>
            <h3 className="text-white font-medium text-lg mb-3">Entrega eficiente</h3>
            <p className="text-white/70 text-sm font-light leading-relaxed">Logística optimizada para tu operación</p>
          </div>

          <div className="bg-white/5 backdrop-blur-md rounded-2xl p-8 border border-white/10">
            <div className="w-14 h-14 bg-blue-600/90 rounded-xl flex items-center justify-center mx-auto mb-5">
              <i className="ri-flask-line text-white text-2xl"></i>
            </div>
            <h3 className="text-white font-medium text-lg mb-3">Mezclas personalizadas</h3>
            <p className="text-white/70 text-sm font-light leading-relaxed">Soluciones químicas adaptadas a tu industria</p>
          </div>
        </div>
      </div>

      {/* Carousel Indicators */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-20 flex items-center gap-2">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`h-1.5 rounded-full transition-all cursor-pointer ${
              index === currentSlide 
                ? 'w-8 bg-white' 
                : 'w-1.5 bg-white/40 hover:bg-white/60'
            }`}
          />
        ))}
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 right-8 animate-bounce">
        <button 
          onClick={() => scrollToSection('nosotros')} 
          className="w-10 h-10 flex items-center justify-center bg-white/10 backdrop-blur-sm rounded-full border border-white/20 cursor-pointer hover:bg-white/20 transition-colors"
        >
          <i className="ri-arrow-down-line text-white text-lg"></i>
        </button>
      </div>
    </section>
  );
}
